import { gql } from 'graphql-request';
import {
  GroupedItemItemID,
  GroupedItemItemName,
  GroupedItemUUID
} from '../groupedItemsTypes';

export interface CacheFetchSelectGroupedItemsQueryResponse {
  uuid: GroupedItemUUID;
  itemId: GroupedItemItemID;
  itemName: GroupedItemItemName;
}

export const CACHE_FETCH_SELECT_GROUPED_ITEMS_QUERY = gql`
  query CacheSelectGroupedItems(
    $filters: GroupedItemsFilters
    $groupItemsByType: Boolean
    $groupBy: [ItemGroupBy]
    $limit: Int
    $sort: [GroupedItemsSortEnum!]
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    groupedItems(
      filters: $filters
      groupItemsByType: $groupItemsByType
      groupBy: $groupBy
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        uuid
        itemId
        itemName
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
